import React from "react";
import { useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function Gate({ children }) {
  const { user } = useAuth();
  const navigate = useNavigate();
  if (user?.role === "admin" || user?.membership_status === "approved") return children;
  return (
    <div className="p-8 text-center flex flex-col items-center gap-4 mt-10">
      <div className="w-16 h-16 rounded-full border-2 border-black bg-[#C7A656] flex items-center justify-center">
        <Lock size={26} />
      </div>
      <h2 className="font-display font-bold text-2xl uppercase">Members Only</h2>
      <p className="text-sm text-[#554E40] max-w-xs">
        This part of the club is reserved for approved members. Apply for membership to unlock offers, chat, and bookings.
      </p>
      <button className="atc-btn btn-primary px-8" onClick={() => navigate("/membership")} data-testid="gate-apply-btn">
        Apply For Membership
      </button>
    </div>
  );
}
